export default __webpack_public_path__ + "static/media/Gunderland Bracers.37016015.jpg";